export default __webpack_public_path__ + "static/media/avatar_placeholder-3.411760e1.png";